var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/sms-tracking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms-tracking"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5859 19.4793H6.41927C6.04344 19.4793 5.73177 19.1677 5.73177 18.7918C5.73177 18.416 6.04344 18.1043 6.41927 18.1043H15.5859C18.2076 18.1043 19.4818 16.8302 19.4818 14.2085V7.79183C19.4818 5.17016 18.2076 3.896 15.5859 3.896H6.41927C3.7976 3.896 2.52344 5.17016 2.52344 7.79183C2.52344 8.16766 2.21177 8.47933 1.83594 8.47933C1.4601 8.47933 1.14844 8.16766 1.14844 7.79183C1.14844 4.446 3.07344 2.521 6.41927 2.521H15.5859C18.9318 2.521 20.8568 4.446 20.8568 7.79183V14.2085C20.8568 17.5543 18.9318 19.4793 15.5859 19.4793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9999 11.7975C10.2299 11.7975 9.45071 11.5591 8.85488 11.0733L5.98571 8.78164C5.69238 8.54331 5.63738 8.11247 5.87571 7.81914C6.11405 7.5258 6.54487 7.47081 6.8382 7.70914L9.70737 10.0008C10.404 10.56 11.5865 10.56 12.2832 10.0008L15.1524 7.70914C15.4457 7.47081 15.8857 7.51664 16.1149 7.81914C16.3532 8.11247 16.3074 8.55247 16.0049 8.78164L13.1357 11.0733C12.549 11.5591 11.7699 11.7975 10.9999 11.7975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.33594 15.8125H1.83594C1.4601 15.8125 1.14844 15.5008 1.14844 15.125C1.14844 14.7492 1.4601 14.4375 1.83594 14.4375H7.33594C7.71177 14.4375 8.02344 14.7492 8.02344 15.125C8.02344 15.5008 7.71177 15.8125 7.33594 15.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.58594 12.146H1.83594C1.4601 12.146 1.14844 11.8343 1.14844 11.4585C1.14844 11.0827 1.4601 10.771 1.83594 10.771H4.58594C4.96177 10.771 5.27344 11.0827 5.27344 11.4585C5.27344 11.8343 4.96177 12.146 4.58594 12.146Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailTrack);
export default __webpack_public_path__ + "static/media/mail_track.6dfdecfe6fe6ef9c5c68be232d2994f4.svg";
export { ForwardRef as ReactComponent };